var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ mobile: _vm.isMobile }},[_c('FixedHeader',{attrs:{"header":_vm.header,"topOnMobile":_vm.subheaderTopOnMobile,"isAccessibleForAPNICStaff":_vm.isAccessibleForAPNICStaff}}),_c('div',{staticClass:"page-content",class:{ 'position-relative': _vm.isWithoutBackground }},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"card-wrapper",class:{
          'without-background': _vm.isWithoutBackground
        }},[_vm._t("default")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }